// removed by extract-text-webpack-plugin
module.exports = {"FooterNav":"_1QvcYV2w","FooterNav--row":"_2pFAZaPp","FooterNav--column":"_2Mwfzzhp","MenuItem":"kTBjKw70","Active--row":"_6txEehTo","Active--column":"_1Ip5Hv3I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer-nav/footer-nav-component.styles.scss
// module id = 527
// module chunks = 0